<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon16/filter-2">
<path id="vec" d="M2 5H1M12 5H15" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round"/>
<path id="vec_2" d="M4 11H1M14 11H15" stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round"/>
<circle id="Ellipse 1313" cx="7" cy="5" r="2" fill="var(--icon-color)"/>
<circle id="Ellipse 1314" cx="9" cy="11" r="2" fill="var(--icon-color)"/>
</g>
</svg>
